/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[signupMobileStepper]'
})
export class MobileStepperDirective implements OnInit {

  @Input() totalSteps = 0;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) { }

  private totalStepsDiv: any | undefined = undefined;

  private forwardSlash: any | undefined = undefined;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.manageMobileStepper();
  }

  ngOnInit(): void {
    this.createForwardSlashElement();
    this.createTotalStepsElement();
    this.manageMobileStepper();
  }

  createForwardSlashElement() {
    this.forwardSlash = this.renderer.createElement('div');

    this.renderer.setStyle(this.forwardSlash, 'font-size', '3.3rem');
    this.renderer.setStyle(this.forwardSlash, 'color', 'white');
    this.renderer.setStyle(this.forwardSlash, 'position', 'absolute');
    this.renderer.setStyle(this.forwardSlash, 'top', '40px');
    this.renderer.setStyle(this.forwardSlash, 'left', '42px');
    this.renderer.setStyle(this.forwardSlash, 'font-weight', 'lighter');
    this.renderer.setStyle(this.forwardSlash, 'z-index', '100');
    this.renderer.setStyle(this.forwardSlash, 'transform', 'rotate(20deg)');
    this.renderer.setProperty(this.forwardSlash, 'innerHTML', `/`);
  }

  createTotalStepsElement() {
    this.totalStepsDiv = this.renderer.createElement('div');

    this.renderer.setStyle(this.totalStepsDiv, 'font-size', '1.5rem');
    this.renderer.setStyle(this.totalStepsDiv, 'color', 'white');
    this.renderer.setStyle(this.totalStepsDiv, 'position', 'absolute');
    this.renderer.setStyle(this.totalStepsDiv, 'top', '65px');
    this.renderer.setStyle(this.totalStepsDiv, 'left', '55px');
    this.renderer.setStyle(this.totalStepsDiv, 'font-weight', 'normal');
    this.renderer.setStyle(this.totalStepsDiv, 'z-index', '100');
    this.renderer.setProperty(this.totalStepsDiv, 'innerHTML', `${this.totalSteps}`);
  }

  private manageMobileStepper() {
    const width = window.innerWidth;

    if (width <= 575) {
      this.renderer.appendChild(this.elementRef.nativeElement, this.forwardSlash);
      this.renderer.appendChild(this.elementRef.nativeElement, this.totalStepsDiv);
    }
    if (width > 575) {
      this.renderer.removeChild(this.renderer.parentNode(this.elementRef.nativeElement), this.totalStepsDiv);
      this.renderer.removeChild(this.renderer.parentNode(this.elementRef.nativeElement), this.forwardSlash);
    }
  }
}
